"use client";
import { useVisuallyHidden } from "../visually-hidden/visually-hidden.js";
import { createElement, createHook, forwardRef } from "@ariakit/react-utils";
//#region src/focus-trap/focus-trap.tsx
const TagName = "span";
/**
* Returns props to create a `FocusTrap` component.
* @see https://ariakit.com/components/focus-trap
* @example
* ```jsx
* const props = useFocusTrap();
* <Role {...props} />
* ```
*/
const useFocusTrap = createHook(function useFocusTrap(props) {
	props = {
		"data-focus-trap": "",
		tabIndex: 0,
		"aria-hidden": true,
		...props,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			...props.style
		}
	};
	props = useVisuallyHidden(props);
	return props;
});
/**
* Renders a focus trap element.
* @see https://ariakit.com/components/focus-trap
* @example
* ```jsx
* <FocusTrap onFocus={focusSomethingElse} />
* ```
*/
const FocusTrap = forwardRef(function FocusTrap(props) {
	return createElement(TagName, useFocusTrap(props));
});
//#endregion
export { FocusTrap, useFocusTrap };

//# sourceMappingURL=focus-trap.js.map